import { EBusinessSolution } from '@aca-new/app/shared/models/enums/business-solution.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppBookTypeService {
  public getBookType(serviceType: EServiceType): EBusinessSolution {
    let bookType: EBusinessSolution;

    switch (serviceType.toUpperCase()) {
      case EServiceType.PSI:
      case EServiceType.PEO:
      case EServiceType.CLC:
      case EServiceType.DUPRO:
      case EServiceType.SC:
      case EServiceType.SP:
      case EServiceType.PM:
      case EServiceType.IPC:
      case EServiceType.SR:
        bookType = EBusinessSolution.INSPECTIONS;
        break;

      case EServiceType.LT:
        bookType = EBusinessSolution.LAB_TESTING;
        break;

      case EServiceType.SABER:
      case EServiceType.SASO:
      case EServiceType.SASOREGISTRATION.toUpperCase():
      case EServiceType.GMARK:
      case EServiceType['G-MARK']:
        bookType = EBusinessSolution.CERTIFICATIONS;
        break;

      case EServiceType.EA:
      case EServiceType.MA:
      case EServiceType.DR:
      case EServiceType.CTPAT:
      case EServiceType.CTPAT.replace('-', ''):
      case EServiceType.STRA:
      case EServiceType.ENVA:
      case EServiceType.GMP:
      case EServiceType.GHP:
        bookType = EBusinessSolution.AUDITS;
        break;
      case EServiceType.GGAP:
        bookType = EBusinessSolution.WQS;
        break;
      case EServiceType.BRCGS:
      case EServiceType.IFS:
      case EServiceType.SQF:
        bookType = EBusinessSolution.FOOD_CERTIFICATION;
        break;
      case EServiceType.STS:
        bookType = EBusinessSolution.TRAINING;
        break;
      case EServiceType.CSM:
        bookType = EBusinessSolution.CALLBACKS;
        break;
      case EServiceType.SAQ:
        bookType = EBusinessSolution.SELF_ASSESSMENT;
        break;
      default:
        bookType = '' as EBusinessSolution;
        break;
    }

    return bookType;
  }
}
